import {
  FETCH_IMPACT_REDIRECT_FAILURE,
  FETCH_IMPACT_REDIRECT_LOADING,
  FETCH_IMPACT_REDIRECT_SUCCESS,
} from '../../actions/actionTypes';

interface ImpactState {
  redirectUrl: string | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ImpactState = {
  redirectUrl: null,
  isLoading: false,
  error: null,
};

const ImpactReducer = (state = initialState, action: any): ImpactState => {
  switch (action.type) {
    case FETCH_IMPACT_REDIRECT_LOADING:
      return { ...state, isLoading: action.payload };
    case FETCH_IMPACT_REDIRECT_SUCCESS:
      return { ...state, redirectUrl: action.payload, error: null };
    case FETCH_IMPACT_REDIRECT_FAILURE:
      return { ...state, redirectUrl: null, error: action.payload };
    default:
      return state;
  }
};

export default ImpactReducer;
